import StorageFile from './StorageFile';

export default StorageFile;
